module.exports = __webpack_public_path__ + "media/mypage/images/special/002-98c20c2deef026b8afc296ea4f79af46.jpg";